import axios from '../axios'

export const delNick = (data) => {
  return axios({
      url: '/admin/delUser',
      method: 'get',
      params: {
        delNick: data
      },
      data
  })
}
export const addTMCUser = (data) => {
  return axios({
      url: '/admin/addTMCUser',
      method: 'get',
      data,
      params: {
        tmcNick: data
      }
  })
}
export const delTMCUser = (data) => {
  return axios({
      url: '/admin/delTMCUser',
      method: 'get',
      data,
      params: {
        tmcNick: data
      }
  })
}
export const addDataPushUser = (data) => {
  return axios({
      url: '/admin/addDataPushUser',
      method: 'get',
      data,
      params: {
        dataPushNick: data
      }
  })
}
export const delDataPushUser = (data) => {
  return axios({
      url: '/admin/delDataPushUser',
      method: 'get',
      data,
      params: {
        dataPushNick: data
      }
  })
}
export const resetJdpUser2DataPush = (data) => {
  return axios({
      url: '/admin/resetJdpUser2DataPush',
      method: 'get',
      data,
      params: {
        resetNum: data
      }
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/admin.js